export default __webpack_public_path__ + "static/media/40162.cf96cc17.jpg";